<template>
  <div>
    <div>
      <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
      <h3 class="mt-3">
        {{ $getVisibleNames("teaching.mattercategory", false, "Categoría") }}
        <AlternativeNameButton
          :table_name="'teaching.mattercategory'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'teaching.add_mattercategory'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'teaching.mattercategory',
                  false,
                  'Categoría'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-matter_category-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
          <!-- <button
            v-can="'teaching.add_mattercategory'"
            v-if="allows_crud"
            class="btn btn-secondary btn-sm"
            @click="$bvModal.show(`new-matter_category-modal`)"
          >
            Agregar
            {{
              $getVisibleNames("teaching.mattercategory", false, "Categoría")
            }}
          </button> -->
        </div>
      </div>
      <GenericBTable
        :items="matterCategories"
        :pagination="matterCategories.length"
        :fields="matter_categories_fields"
        :filter="input_search"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
      >
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            v-can="'teaching.change_mattercategory'"
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'teaching.mattercategory',
                  false,
                  'Categoría'
                ),
              })
            "
            :click_button="
              () => $bvModal.show(`edit-matter_category-modal-${row.item.id}`)
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <!-- <button-edit
            @click="$bvModal.show(`edit-matter_category-modal-${row.item.id}`)"
            v-b-tooltip.v-secondary.noninteractive="
              `Editar ${$getVisibleNames(
                'teaching.mattercategory',
                false,
                'Categoría'
              )}`
            "
          ></button-edit> -->
          <ButtonSmall
            v-can="'teaching.delete_mattercategory'"
            :click_button="() => askForDeleteMatterCategory(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'teaching.mattercategory',
                  false,
                  'Categoría'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <!-- <button-delete
            @click="askForDeleteMatterCategory(row.item.id)"
            v-b-tooltip.v-secondary.noninteractive="
              `Eliminar ${$getVisibleNames(
                'teaching.mattercategory',
                false,
                'Categoría'
              )}`
            "
          ></button-delete> -->
          <b-modal
            :id="`edit-matter_category-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'teaching.mattercategory',
                  false,
                  'Categoría'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <MatterCategoryForm
              :MatterCategory="row.item"
              @updated="slotUpdatedMatterCategory"
              :show_title="false"
            ></MatterCategoryForm>
          </b-modal>
        </template>
      </GenericBTable>
    </div>
    <b-modal
      :id="`new-matter_category-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'teaching.mattercategory',
            false,
            'Categoría'
          ),
        })
      "
      size="lg"
    >
      <MatterCategoryForm
        @created="slotCreatedMatterCategory"
      ></MatterCategoryForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "MatterCategoryView",
  components: {
    MatterCategoryForm: () =>
      import(
        "@/components/teaching/CurricularResources/MatterCategory/MatterCategoryForm"
      ),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    input_search: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      matterCategories: names.MATTER_CATEGORIES,
    }),
    allows_crud() {
      const has_permission = this.$hasPermissions(
        "teaching.add_mattercategory"
      );
      if (
        has_permission &&
        this.user &&
        (this.user.group_names.includes(
          "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
        ) ||
          this.user.is_superuser)
      )
        return has_permission;
      else return false;
    },
    matter_categories_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames("teaching.mattercategory", true, "Categorías")
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          // sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "teaching.mattercategory",
            false,
            "Categoría"
          ),
        },
      ];
    },
  },
  methods: {
    askForDeleteMatterCategory(matter_category_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "teaching.mattercategory",
            false,
            "Categoría"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_MATTER_CATEGORY, matter_category_id)
            .then(() => {
              toast(
                this.$getVisibleNames(
                  "teaching.mattercategory",
                  false,
                  "Categoría"
                ) +
                  " " +
                  this.$t("reusable.common.deleted")
              );
            });
        }
      });
    },
    slotCreatedMatterCategory() {
      this.$bvModal.hide("new-matter_category-modal");
    },
    slotUpdatedMatterCategory(matter_category) {
      this.$bvModal.hide(`edit-matter_category-modal-${matter_category.id}`);
    },
  },
  mounted() {},
  created() {
    this.$store.dispatch(names.FETCH_MATTER_CATEGORIES);
  },
};
</script>

<style scoped>
th {
  background-color: var(--primary-color);
  border-radius: 6px;
  box-shadow: 1px 1px 3px rgb(72, 72, 72);
}

.title-header {
  padding: 0;
  margin-top: auto;
}
.search-matter_category {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
</style>